import { createFileRoute } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { SurveyRespondPage } from '@/features/surveys';

export const Route = createFileRoute('/surveys_/$surveyId/respond')({
  component: SurveyRespondRoute,
});

function SurveyRespondRoute(): ReactNode {
  const { surveyId } = Route.useParams();
  return <SurveyRespondPage surveyId={surveyId} />;
}
